// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilePptOutlinedSvg from "@ant-design/icons-svg/es/asn/FilePptOutlined";
import AntdIcon from '../components/AntdIcon';

var FilePptOutlined = function FilePptOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilePptOutlinedSvg
  }));
};

FilePptOutlined.displayName = 'FilePptOutlined';
export default React.forwardRef(FilePptOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FilePptOutlined.js
// module id = 1133
// module chunks = 0